import type { SubscriptionFrequency } from "./SubscriptionFrequency.js";
import type { SubscriptionSize } from "./SubscriptionSize.js";
import { subscriptionFrequencyToWeeksMap } from "./utils/subscriptionFrequencyToWeeksMap.js";
import { subscriptionSizeToAmountMap } from "./utils/subscriptionSizeToAmountMap.js";
import { subscriptionSizeToWeightMap } from "./utils/subscriptionSizeToWeightMap.js";

const fathersChoicePriceByWeight: Record<(typeof subscriptionSizeToWeightMap)[SubscriptionSize], number> = {
	250: 359,
	1000: 1238,
};

/**
 * Returns the reference retail price without tax for a Father’s Choice product.
 *
 * - Without `frequency`: per-unit price (one bag of the given weight).
 * - With `frequency`: normalized monthly price (all units, amortised over a month).
 */
export function getFathersChoicePrice(size: SubscriptionSize, frequency?: SubscriptionFrequency): number {
	const weight = subscriptionSizeToWeightMap[size];
	const unitPrice = fathersChoicePriceByWeight[weight];

	if (frequency === undefined) {
		return unitPrice;
	}

	const amount = subscriptionSizeToAmountMap[size];
	const weeks = subscriptionFrequencyToWeeksMap[frequency];
	return ((365 / (weeks * 7)) * (unitPrice * amount)) / 12;
}
